export const palette = {
  blue: "#1D24A6",
  red: "#F1303E",
  turqoise: "#1FCAC6",
  yellow: "#F9C024",
};
